import React, {Fragment, useState} from "react"; 
import SimpleSidebarItem from "./SimpleSidebarItem";
 
export default function ToggleSidebarItem({menuItem} ) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = (e )  => {
        e.preventDefault();
        setIsOpen(!isOpen);
    };
    return (<>
        <li>
            <button
                type="button"
              
                className={`flex items-center w-full p-2 py-4 text-base transition duration-75  text-white group ${isOpen ? "bg-primary/20" : "  hover:bg-slate-700"} `}
                aria-controls="dropdown-example"
                onClick={toggleDropdown}
            >
                {menuItem.icon}
                <span className={`flex-1 ms-3 text-left rtl:text-right whitespace-nowrap text-xs `}>
                {menuItem.title}
              </span>
                <svg
                    className={`w-3 h-3 transform transition-transform ${
                        isOpen ? "rotate-180" : ""
                    }`}
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                >
                    <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                    />
                </svg>
            </button>
            <ul
                id="dropdown-example"
                style={{backgroundColor:"rgba(0,0,0,0.5)"}}
                className={`${isOpen ? "block" : "hidden"}   divide-y divide-primary/20   `}
            >
                {
                    menuItem.children && menuItem.children?.map((item , index) => (<Fragment key={index}>
                        {
                            (item.children &&  item.children.length>0) ? <>
                                    <ToggleSidebarItem menuItem={item}/>
                                </> :
                                     <SimpleSidebarItem item={item} padding={true}/>

                        }
                    </Fragment>))
                }

            </ul>
        </li>
    </>)
}
